/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Unreadsuffix2Inputs */

const en_notificationcenter_unreadsuffix2 = /** @type {(inputs: Notificationcenter_Unreadsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(unread)`)
};

/**
* | output |
* | --- |
* | "(unread)" |
*
* @param {Notificationcenter_Unreadsuffix2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_unreadsuffix2 = /** @type {((inputs?: Notificationcenter_Unreadsuffix2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Unreadsuffix2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_unreadsuffix2(inputs)
});
export { notificationcenter_unreadsuffix2 as "notificationCenter_unreadSuffix" }